import { render } from "./App.vue?vue&type=template&id=27ef0531"
const script = {}

import exportComponent from "/var/www/easymp/data/www/easymp.ru/src/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__